import snackbarReducer from "./slices/snackbarSlice";
import accountReducer from "./slices/accountSlice";
import extranetReducer from "./slices/extranetSlice";
import prestationsReducer from "./slices/prestationsSlice";
import loadingReducer, {toggleLoading} from "./slices/loadingSlice";
import menuReducer from "./slices/menuSlice";

import {combineReducers} from "redux";

const appReducer = combineReducers({
    menu: menuReducer,
    snackbar: snackbarReducer,
    loading: loadingReducer, // Définitions de l'état loading,
    account: accountReducer, // Définitions des éléments du state lié à l'utilisateur connecté ex: roles, codeEntreprise, ssNum, connexion, type,
    extranet: extranetReducer, // Définitions des éléments du state lié aux données extranet ex: gestion comptes entreprises et gestion comptes assurés
    prestations: prestationsReducer, // Définitions des éléments du state lié aux données prestations ex: décomptes etc...
})

const rootReducer = (state, action) => {
    if (action.type === 'RESET_WEBAPP') {
        state = undefined;
    }
    return appReducer(state, action);
}

export const resetAppAction = () => (dispatch) => {
    dispatch({ type: 'RESET_WEBAPP' });
};

export default rootReducer;
